import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaRegCircleXmark } from "react-icons/fa6";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { fetchDataCategories } from "../../store/slices/apiCategorySlice";
import { fetchDataPackage } from "../../store/slices/apiPackageSlice";
import { fetchDataDrivingSchools } from "../../store/slices/apiDrivingSchoolsSlice";
import { activateGuestFromAdmin } from "../../store/slices/authSlice";
import { payWithCashInDriveSchool } from "../../store/slices/apiPackageSlice";

const AddModalActivateUserCash = ({
  isOpen,
  onClose,
  userId,
  onSuccess,
  userSchoolId,
  driveSchoolUserId,
}) => {
  const dispatch = useDispatch();
  const categoryOptions = useSelector((state) => state.apiCategory.data);
  const packageOptions = useSelector((state) => state.apiPackage.data?.data || []);

  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedPackage, setSelectedPackage] = useState(null);

  useEffect(() => {
    dispatch(fetchDataCategories());
  }, [dispatch]);

  useEffect(() => {
    if (selectedCategory) {
      dispatch(fetchDataPackage({ page: 1, limit: 100, categoryId: selectedCategory.value }));
      setSelectedPackage(null);
    }
  }, [dispatch, selectedCategory]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedCategory || !selectedPackage) {
      toast.error("Ju lutem plotësoni të gjitha fushat!");
      return;
    }

    const selectedPackageObj = packageOptions.find(
      (option) => option.id === selectedPackage.value
    );

    const data = {
      user_id: userId,
      category_id: selectedCategory.value,
      amount: selectedPackageObj?.price,
      paymentDate: new Date().toISOString().slice(0, 19).replace('T', ' '),
      adminPrice: selectedPackageObj?.adminPrice,
      schoolPrice: selectedPackageObj?.schoolPrice,
      driveSchoolId: userSchoolId,
      driveSchoolUserId: driveSchoolUserId,
      isActive: 0,
      cash: 1,
      packages: selectedPackageObj?.name,
      month: selectedPackageObj?.month,
      catName: selectedCategory.label, 
      packageId: selectedPackageObj?.id,
    };

    try {
      await dispatch(payWithCashInDriveSchool(data)).unwrap();
      toast.success("Pagesa u krye me sukses!");
      if (onSuccess) onSuccess();
      onClose();
      setSelectedCategory(null);
      setSelectedPackage(null);
    } catch (error) {
      toast.error("Gabim gjatë pagesës!");
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6">
      <div className="bg-gray-900 bg-opacity-40 absolute inset-0" onClick={onClose}></div>
      <div className="relative bg-white rounded-lg shadow-lg w-full max-w-xl min-h-[400px] max-h-[98vh] overflow-y-auto">
        <button
          type="button"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-full w-8 h-8 flex justify-center items-center"
        >
          <FaRegCircleXmark style={{ width: 20, height: 20 }} />
        </button>
        <div className="p-6 text-center">
          <h3 className="mb-5 text-xl font-normal text-gray-500 dark:text-gray-400">
            Aktivizo Kategorinë
          </h3>
          <form className="space-y-5 text-start" onSubmit={handleSubmit}>
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Kategoria:
              </label>
              <Select
                name="category"
                value={selectedCategory}
                onChange={setSelectedCategory}
                options={categoryOptions.map((option) => ({ value: option.id, label: option.name }))}
                className="text-sm"
                classNamePrefix="react-select"
                placeholder="Zgjidh kategorinë"
                isClearable
              />
            </div>
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Paketa:
              </label>
              <Select
                name="package"
                value={selectedPackage}
                onChange={setSelectedPackage}
                options={packageOptions
                  .filter((option) => option.category_id === selectedCategory?.value)
                  .map((option) => ({ value: option.id, label: option.name }))}
                className="text-sm"
                classNamePrefix="react-select"
                placeholder="Zgjidh pakon"
                isClearable
              />
            </div>
            <div className="flex justify-center flex-wrap gap-2">
              <button
                type="submit"
                className="text-white bg-blue-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              >
                Aktivizo
              </button>
              <button
                type="button"
                onClick={onClose}
                className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
              >
                Anulo
              </button>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};

export default AddModalActivateUserCash;
